(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wr-photo-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initReviews(root) {
    var grid = root.querySelector('[data-wr-grid]');
    var pager = root.querySelector('[data-wr-pager]');
    if (!grid || !pager) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.wr-rev__card'));
    var per = parseInt(root.getAttribute('data-per'), 10) || 12;
    var pages = Math.max(1, Math.ceil(cards.length / per));
    var cur = 1, firstRun = true;

    function pageList(c, n) {
      var arr = [], out = [], prev = 0, i;
      for (i = 1; i <= n; i++) { if (i === 1 || i === n || (i >= c - 1 && i <= c + 1)) arr.push(i); }
      arr.forEach(function (i) { if (i - prev > 1) out.push('...'); out.push(i); prev = i; });
      return out;
    }
    function mkBtn(label, page, o) {
      o = o || {};
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wr-rev__pg' + (o.cls ? ' ' + o.cls : '');
      b.textContent = label;
      if (o.current) b.setAttribute('aria-current', 'true');
      if (o.disabled) b.disabled = true;
      if (!o.disabled && !o.dots) b.addEventListener('click', function () { go(page); });
      return b;
    }
    function renderPager() {
      pager.innerHTML = '';
      if (pages <= 1) return;
      pager.appendChild(mkBtn('‹', cur - 1, { disabled: cur === 1 }));
      pageList(cur, pages).forEach(function (p) {
        if (p === '...') pager.appendChild(mkBtn('…', 0, { dots: true, disabled: true, cls: 'wr-rev__pg--dots' }));
        else pager.appendChild(mkBtn(String(p), p, { current: p === cur }));
      });
      pager.appendChild(mkBtn('›', cur + 1, { disabled: cur === pages }));
    }
    function go(p) {
      cur = Math.min(Math.max(1, p), pages);
      var s = (cur - 1) * per, e = s + per;
      cards.forEach(function (c, i) { if (i >= s && i < e) c.removeAttribute('hidden'); else c.setAttribute('hidden', ''); });
      renderPager();
      if (!firstRun) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      firstRun = false;
    }
    go(1);

    // write-a-review modal
    var modal = document.getElementById('wr-rev-modal');
    if (modal) {
      var openBtns = root.querySelectorAll('[data-wr-open]');
      var form = modal.querySelector('.wr-rev__form');
      var thanks = modal.querySelector('[data-wr-thanks]');
      function open() {
        if (form) form.hidden = false;
        if (thanks) thanks.hidden = true;
        var sb = form && form.querySelector('.wr-rev__submit');
        if (sb) { sb.disabled = false; sb.textContent = 'Submit review'; }
        modal.classList.add('is-open'); document.body.style.overflow = 'hidden';
      }
      function close() { modal.classList.remove('is-open'); document.body.style.overflow = ''; }
      Array.prototype.forEach.call(openBtns, function (b) { b.addEventListener('click', open); });
      Array.prototype.forEach.call(modal.querySelectorAll('[data-wr-close]'), function (b) { b.addEventListener('click', close); });
      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      var ratingInput = modal.querySelector('[data-wr-rating]');
      var hp = modal.querySelector('.wr-rev__hp');
      var pick = modal.querySelector('[data-wr-starpick]');
      if (pick) {
        var stars = Array.prototype.slice.call(pick.querySelectorAll('.wr-rev__spick'));
        stars.forEach(function (st) {
          st.addEventListener('click', function () {
            var v = parseInt(st.getAttribute('data-v'), 10);
            stars.forEach(function (s2, i) { s2.classList.toggle('is-on', i < v); });
            if (ratingInput) ratingInput.value = v + ' / 5';
          });
        });
      }
      if (form) form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (hp && hp.value) { form.hidden = true; if (thanks) thanks.hidden = false; return; } // honeypot: silently drop bots
        if (!form.checkValidity()) { form.reportValidity(); return; }
        var sb = form.querySelector('.wr-rev__submit');
        if (sb) { sb.disabled = true; sb.textContent = 'Submitting…'; }
        // POST to Shopify's contact endpoint -> emails the store. Fire-and-forget: the mail is sent
        // server-side regardless of the response, and nothing publishes to the site automatically.
        try { fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'text/html' } }).catch(function () {}); } catch (err) {}
        form.hidden = true; if (thanks) thanks.hidden = false;
      });
    }
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('.wr-rev'), initReviews); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

  } catch(e) { console.error(e); }
})();
})();
